import { createFileRoute } from "@tanstack/react-router";
import { InvitingMembers } from "@/routes/help/inviting-members";

export const Route = createFileRoute("/dashboard/help/inviting-members")({
	component: InvitingMembers,
});
